<template>
  <v-container class="px-0 my-0 pt-0 my-lg-3">
    <v-row class="mt-0 mt-lg-3">
      <v-col class="v-col-12 px-5 px-lg-0 v-col-lg-12">
        <div class="w-100 bg-lg-white pa-2 pa-lg-5">
          <v-breadcrumbs class="pa-0 d-none d-lg-block">
            <v-breadcrumbs-item class="text-color-0">Home</v-breadcrumbs-item>
            <v-breadcrumbs-divider><v-icon icon="mdi-chevron-right text-color-1"></v-icon></v-breadcrumbs-divider>
            <v-breadcrumbs-item class="text-color-0">Favoritos</v-breadcrumbs-item>
          </v-breadcrumbs>
          <v-row class="mt-0 mt-lg-3 d-none d-lg-flex">
            <v-col class="d-flex align-center">
              <b class="text-color-0">{{ getCount }} {{ getCount == 1 ? 'produto':'produtos'}}</b>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-btn-toggle v-model="order" group>
                <v-btn value="0" class="text-color-0">
                  A-Z
                </v-btn>
                <v-btn value="1" class="text-color-0">
                  Z-A
                </v-btn>
                <v-btn value="2" class="text-color-0">
                  Maior preço
                </v-btn>
                <v-btn value="3" class="text-color-0">
                  Menor preço
                </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
          <v-row v-if="paginacao > 0 && getProdutosFeed.length > 0" class="mt-0 mt-lg-3">
            <v-col v-for="p in getProdutosFeed" :key="p.isu" class="v-col-12 pa-0 pa-lg-2 v-col-xl-3 d-flex justify-center v-col-lg-3">
              <Product :product="p"></Product>
            </v-col>
          </v-row>
          <v-row v-else-if="paginacao > 0" class="my-6">
            <v-col class="v-col-12 pa-0 pa-lg-2 d-flex justify-center">
            <span class="text-color-1">Nenhum produto encontrado.</span>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Product from '@/components/Product.vue';
import { capitalize } from '@/store/services/utils.js';
export default {
  name: "Favoritos",
  components: {
    Product
  },
  data(){
    return {
      name: '',
      isLoading: false,
      loadingProdutos: true,
      paginacao: 0,
      order: 0
    }
  },
  computed: {
    ...mapGetters('products', {
      getProdutosFeed: 'getProdutosFeed',
      getCount: 'getCount'
    }),
  },
  watch: {
    "order"(){
      this.Nav();
    }
  },
  methods: {
    ...mapActions('main', {
      setConfig: 'setConfig',
    }),
    ...mapActions('products', {
      getFavorites: 'getFavorites'
    }),
    capitalize,
    Nav(){
      this.paginacao = 0;
        this.getFavorites({ "parametros": "0/"+this.order }).then(function(){
            this.isLoading = false;
            this.loadingProdutos = true;
            this.paginacao = 1;
        }.bind(this));
    },
    scroll(){
      window.addEventListener('scroll', this.updateFeedScroll);
    },
    updateFeedScroll: function() {
      let bottomOfWindow = (document.documentElement.scrollTop + window.innerHeight) > (document.documentElement.offsetHeight - 2400);
      if (bottomOfWindow && document.documentElement.scrollTop > 0) {
        if(this.loadingProdutos && !this.isLoading){
          this.isLoading = true;
          this.getFavorites({ "parametros": this.paginacao+"/"+this.order }).then(function(response){
            if(!response){
              this.loadingProdutos = false;
            }
            this.paginacao += 1;
            this.isLoading = false;
          }.bind(this));
        }
      }
    }
  },
  mounted() {
    this.setConfig().then(function(retorno){
      if(retorno){
        this.scroll();
        this.Nav();
      } else {
        this.emitter.emit('dialogStores');
      }
      this.emitter.emit("sendAnalyticsView", { screen_name: this.$options.name } );
    }.bind(this))
    .catch(function () {
      this.$router.push("/baixeoapp");
    }.bind(this));
  },
  unmounted(){
    window.removeEventListener('scroll', this.updateFeedScroll);
  }
}
</script>